import { ChangeDetectionStrategy, Component, ElementRef, inject, OnInit, signal, ViewChild } from '@angular/core';
import { MatDatepicker, MatDatepickerInputEvent, MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { ExpiryStateStore } from '../../../core/store/expiry-date.store';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ClaimStore } from '../../../core/store/claim-store';

@Component({
  selector: 'emma-expiry-dialog',
  imports: [MatFormFieldModule, MatInputModule, MatDatepickerModule, MatIconModule, DatePipe, FormsModule, CommonModule],
  templateUrl: './expiry-dialog.html',
  styleUrls: ['./expiry-dialog.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExpiryDialogComponent implements OnInit {
  @ViewChild('picker') public datePicker!: MatDatepicker<Date>;
  @ViewChild('dateInput', { read: ElementRef }) public dateInput!: ElementRef<HTMLInputElement>;

  private readonly expiryStateService = inject(ExpiryStateStore);
  public selectedDate = signal<Date | null>(null);
  public invalidDate = signal<boolean>(false);
  private readonly store = inject(ClaimStore);

  constructor(
    private readonly dialogRef: MatDialogRef<ExpiryDialogComponent>
  ) { }

  public ngOnInit() {
    this.selectedDate.set(this.expiryStateService.selectedExpiryDate());
  }

  public onDateChange(event: MatDatepickerInputEvent<Date>): void {
    if (event.value) {
      this.selectedDate.set(event.value);
      this.invalidDate.set(false);
    } else {
      const nativeValue = this.dateInput?.nativeElement?.value ?? '';
      this.invalidDate.set(nativeValue.trim().length > 0);
    }
  }

  public onCancel(): void {
    this.dialogRef.close();
  }

  public onClearAll(): void {
    this.selectedDate.set(null);
    this.invalidDate.set(false);
    this.resetDatePicker();
  }

  public onRemoveSelection(): void {
    this.selectedDate.set(null);
    this.invalidDate.set(false);
    this.resetDatePicker();
  }

  public onConfirmSelection(): void {
    this.expiryStateService.setSelectedDate(this.selectedDate());
    this.store.selectedExpiryDate.set(this.selectedDate());
    this.dialogRef.close({
      selectedDate: this.selectedDate()
    });
  }

  private resetDatePicker(): void {
    if (this.dateInput?.nativeElement) {
      this.dateInput.nativeElement.value = '';
    }
  }
}
